import * as z from "zod"
import { stringRequired } from "@/models/common"
import { ContactChannel } from "@/types/__generated__/union-types"

const CONTACT_CHANNELS: Record<ContactChannel, ContactChannel> = {
  APP: "APP",
  EMAIL_AND_SMS: "EMAIL_AND_SMS",
  NO_CHANNEL: "NO_CHANNEL",
}

export const countrySelectorSchema = z.object({
  postalCode: stringRequired,
  city: stringRequired,
  country: stringRequired,
  houseNumberStreet: stringRequired,
})

export type CountrySelectorFormSchema = z.infer<typeof countrySelectorSchema>

export { CONTACT_CHANNELS }
